import { PortableText, type PortableTextBlock } from 'next-sanity';

import { Link } from '#/components/Link';

import { highlightTextNodes } from './Headline';

type Props = {
  value: PortableTextBlock[];
  className?: string;
  /** When set, text wrapped in `{curly brackets}` gets this highlight class. */
  highlightClass?: string;
};

export function BasicText({ value, className, highlightClass }: Props) {
  return (
    <div className={className}>
      <PortableText
        value={value}
        components={{
          ...(highlightClass
            ? {
                block: {
                  normal: ({ children }) => (
                    <p>{highlightTextNodes(children, highlightClass)}</p>
                  ),
                },
              }
            : {}),
          marks: {
            internalLink: ({ value, children }) => {
              return (
                <Link href={value.href} target={value.target}>
                  {children}
                </Link>
              );
            },
            externalLink: ({ value, children }) => {
              return (
                <Link href={value.href} target={value.target}>
                  {children}
                </Link>
              );
            },
          },
        }}
      />
    </div>
  );
}
